<template>
  <div class="message-container">
    <div class="title-box">
      <div class="title-left">
        <div class="sign"></div>
        <span>{{ title || "机场报文" }}</span>
      </div>
      <div class="title-right"></div>
    </div>
    <div class="head-box">
      <div class="func-cell" @click="showPicker = true">
        <span v-show="currList.length > 0">{{ columnsText[selectIndex] }}</span
        ><i v-show="currList.length > 0" class="my-right" />
      </div>
    </div>
    <div class="body-box">
      <!--eslint-disable-->
      <div
              class="message-card"
              v-for="(item, key) in currList"
              v-bind:key="key"
      >
        <div class="card-head">
          <div class="card-left">
            <span>{{
              columns[selectIndex] +
                " " +
                tafObject[columns[selectIndex]].airportName
            }}</span>
            <span>({{ item.issueTime }})</span>
          </div>
          <div
                  class="card-right"
                  @click="showTransLate(columns[selectIndex], item)"
          >
            <span
            ><img
                    :src="
                  active.indexOf(item.issueTime) === -1
                    ? translateSrc
                    : utranslateSrc
                "
            />{{
                active.indexOf(item.issueTime) === -1 ? "翻译" : "收起"
              }}</span
            >
          </div>
        </div>
        <div class="card-body">
          <span>{{ Object.prototype.toString.call(item.reportContent) === '[object Array]'? item.reportContent[0]:item.reportContent }}</span>
          <span v-show="Object.prototype.toString.call(item.reportContent) === '[object Array]'">{{ item.reportContent.length>1?item.reportContent[1]:'' }}</span>
        </div>
        <div :class="{'trans-body-hide': active.indexOf(item.issueTime) === -1,'trans-body-show': active.indexOf(item.issueTime) !== -1}" v-html="translateStr[0]"></div>
        <div v-show="translateStr.length>1" :class="{'trans-body-hide': active.indexOf(item.issueTime) === -1,'trans-body-show': active.indexOf(item.issueTime) !== -1}" v-html="translateStr[1]"></div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
              show-toolbar
              :columns="columnsText"
              @cancel="showPicker = false"
              @confirm="onConfirm"
              item-height="40"
              visible-item-count="3"
      />
    </van-popup>
    <van-overlay :show="pageLoading" @click="show = false">
      <van-loading type="spinner" />
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "message",
  data() {
    return {
      pageLoading: false,
      title: "",
      showPicker: false,
      columnsText: [
        "ZWYT 于田机场",
        "ZWZS 昭苏机场",
        "ZWAT 阿勒泰机场",
        "ZWCM 且末机场",
        "ZWFY 富蕴机场",
        "ZWHM 哈密机场",
        "ZWKC 库车机场",
        "ZWKL 库尔勒机场",
        "ZWKM 克拉玛依机场",
        "ZWKN 喀纳斯机场",
        "ZWNL 那拉提机场",
        "ZWRQ 若羌机场",
        "ZWSC 莎车机场",
        "ZWSH 喀什机场",
        "ZWTC 塔城机场",
        "ZWTN 和田机场",
        "ZWYN 伊宁机场",
        "ZWTL 吐鲁番机场",
        "ZWBL 博乐机场",
        "ZWTS 图木舒克机场"
        "ZWAL 阿拉尔机场"
        "ZWTK 塔什库尔干机场"
        "ZWHJ 巴音布鲁克机场"
        "ZWQT 奇台江布拉克机场"
      ],
      selectIndex: 0,
      currList: [],
      // 闲置
      columns: [
        "ZWYT",
        "ZWZS",
        "ZWAT",
        "ZWCM",
        "ZWFY",
        "ZWHM",
        "ZWKC",
        "ZWKL",
        "ZWKM",
        "ZWKN",
        "ZWNL",
        "ZWRQ",
        "ZWSC",
        "ZWSH",
        "ZWTC",
        "ZWTN",
        "ZWYN",
        "ZWTL",
        "ZWBL",
        "ZWTS"
        "ZWAL"
        "ZWTK"
        "ZWHJ"
        "ZWQT"
      ],
      active: [],
      tafObject: {},
      translateStr: [],
      transClickTxt: "翻译",
      lastDom: "",
      translateSrc: require("../../assets/translation.png"),
      utranslateSrc: require("../../assets/Packup.png"),
      show: false
    };
  },
  created() {
    let that = this;
    that.getData();
  },
  watch: {
    tafObject(v) {
      this.getColumns();
      this.currList =
        Object.keys(v).length > 0
          ? v[this.columns[this.selectIndex]].reportInfos
          : [];
    },
    selectIndex(v) {
      this.currList =
        Object.keys(this.tafObject).length > 0
          ? this.tafObject[this.columns[v]].reportInfos
          : [];
    }
  },
  methods: {
    onConfirm(value, index) {
      this.selectIndex = index;
      this.showPicker = false;
    },
    getData() {
      let that = this;
      that.pageLoading = true;
      let param = {
        user: that.$store.state.api_user,
        password: that.$store.state.api_password,
        version: 3,
        funname:
          "project/xinjiangaviation/forecastdata/GetNearlyReportByAirportCodes",
        funversion: 2,
        airportCodes:
          "ZWAT,ZWCM,ZWFY,ZWKC,ZWKL,ZWKM,ZWSH,ZWTC,ZWTN,ZWYN,ZWHM,ZWNL,ZWKN,ZWSC,ZWRQ,ZWTL,ZWBL,ZWTS,ZWHJ,ZWQT",
        queryTime: this.$btools.fuc.formatDate(
          new Date(),
          "yyyy-MM-dd hh:mm:ss"
        ),
        beginSession: -30,
        endSession: 0,
        types: "taf,metar,speci"
      };
      /* let param = {
        user: that.$store.state.api_user,
        password: "123456",
        version: 3,
        funversion: 1,
        airportCodes: "ZWAT,ZWCM,ZWFY,ZWKC,ZWKL,ZWKM,ZWSH,ZWTC,ZWTN,ZWYN,ZWHM,ZWNL,ZWKN,ZWSC,ZWRQ,ZWTL,ZWBL,ZWTS",
        beginSession: -48,
        endSession: 0,
        type: "taf",
        funname: "project/xinjiangaviation/forecastdata/GetNearlyReportByAirportCodes",
        queryTime: this.$btools.fuc.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss")
      };*/
      this.$http
        .get("/Services?" + this.$qstring.stringify(param))
        .then(r => {
          that.pageLoading = false;
          console.log("机场报文源数据：", r);
          that.tafObject = r["data"];
        })
        .catch(e => {
          that.pageLoading = false;
          console.log("获取报文信息异常:", e);
        });
    },
    getColumns() {
      const that = this;
      const _valarr = [];
      const _txtarr = [];
      for (let i in that.tafObject) {
        if (_valarr.indexOf(i) < 0) {
          _valarr.push(i);
          _txtarr.push(`${i} ${that.tafObject[i]["airportName"]}机场`);
        }
      }
      that.columns = _valarr;
      that.columnsText = _txtarr;
    },
    showTransLate(key, item) {
      console.log("key,item", key, item);
      const _idx = this.active.indexOf(item.issueTime);
      console.log("this.translateStr", this.translateStr);
      if (_idx > -1) {
        this.active.splice(_idx, 1);
      } else {
        this.active = [];
        this.active.push(item.issueTime);
      }
      if (
        Object.prototype.toString.call(item.reportContent) === "[object Array]"
      ) {
        for (let i = 0; i < item.reportContent.length; i++) {
          this.translateStr.push(
            `<span class="amt-title">${this.$btools.fuc
              .getAMTTxt(item.reportContent[i])
              .split("<br>")
              .join('</span><span class="amt-cell">')}</span>`
          );
        }
      } else {
        this.translateStr = [];
        this.translateStr.push(
          `<span class="amt-title">${this.$btools.fuc
            .getAMTTxt(item.reportContent)
            .split("<br>")
            .join('</span><span class="amt-cell">')}</span>`
        );
      }
      this.show = true;
    },
    hideTranslate() {
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.message-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  .title-box {
    display: flex;
    flex-direction: row;
    height: 8%;
    //height: px2rem(58);
    width: 95%;
    .title-left {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      width: 32.5%;
      .sign {
        width: 3px;
        height: px2rem(16);
        background-image: linear-gradient(180deg, #fe5936 0%, #fca656 100%);
      }
      span {
        font-family: PingFangSC-Semibold;
        font-size: px2rem(18);
        color: #ffffff;
        margin-left: px2rem(4);
      }
    }
    .title-right {
      height: 100%;
      width: 67.5%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
    /*border: 1px solid violet;*/
  }
  .head-box {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    //height: px2rem(45);
    height: 8%;
    width: 95%;
    .func-cell {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: px2rem(44);
      width: 100%;
      background-image: linear-gradient(142deg, #2b2f34 0%, #2b2f33 100%);
      box-shadow: inset 0px 3px 6px 0px rgba(0, 0, 0, 0.24),
        inset 0px -2px 2px 0px rgba(255, 255, 255, 0.09);
      border-radius: px2rem(12);
      span {
        font-size: px2rem(16);
        color: #a0a2a4;
        margin-left: px2rem(17);
      }
      .my-right {
        border: solid rgb(151, 151, 151);
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 3px;
        margin-right: px2rem(19);
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
    }
    /*border: 1px solid greenyellow;*/
  }
  .body-box {
    height: 82%;
    width: 95%;
    //margin-top: px2rem(12);
    overflow: scroll;
    margin-top: 2%;
    .message-card {
      width: 100%;
      border-radius: 5px;
      border: 1px solid #ddd;
      background-image: linear-gradient(
        162deg,
        rgb(52, 57, 62),
        rgb(52, 57, 62)
      );
      border-image: linear-gradient(139deg, rgb(69, 74, 83), rgb(36, 40, 45));
      box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.09);
      margin-bottom: px2rem(10);
      .card-head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: px2rem(62);
        width: 95%;
        margin: auto;
        .card-left {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span {
            line-height: px2rem(16);
            font-size: px2rem(15);
            color: #686868;
          }
          & > span:nth-of-type(1) {
            color: #e02c00;
          }
        }
        .card-right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            height: px2rem(14);
            width: px2rem(14);
          }
          span {
            font-size: px2rem(13);
            color: #e95e00;
          }
        }
      }
      .card-body {
        display: flex;
        flex-direction: column;
        width: 95%;
        margin: auto;
        span {
          line-height: px2rem(16);
          color: #a9abad;
          font-size: px2rem(14);
          padding: px2rem(10) 0;
          border-top: 2px solid #4a4a4a;
          /*padding: px2rem(5) px2rem(10);*/
        }
      }
      .trans-body-hide {
        display: none;
      }
      .trans-body-show {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin: auto;
        margin-bottom: px2rem(5);
        padding: px2rem(5) px2rem(5);
        border-radius: 10px;
        color: rgb(169, 171, 173);
        height: auto;
        width: 87%;
        background-image: linear-gradient(
          162deg,
          rgb(45, 51, 57),
          rgb(36, 40, 45)
        );
        border-image: linear-gradient(157deg, rgb(78, 78, 78), rgb(34, 38, 43));
        box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.21);
        /deep/.amt-title {
          align-self: center;
        }
        /deep/span {
          font-size: px2rem(14);
          line-height: px2rem(18);
        }
      }
    }
  }
}
</style>
